import { useForm } from '@inertiajs/react'
import { BackofficeLayout } from '@/components/layout/BackofficeLayout'
import { FormSection } from '@/components/backoffice/FormSection'
import { Button } from '@/components/ui/button'
import { Input } from '@/components/ui/input'

type Props = { country: { id: string; code: string; name: string } }

export default function StatesNew({ country }: Props) {
  const { data, setData, post, processing, errors } = useForm({ code: '', name: '' })

  return (
    <BackofficeLayout title={`New State in ${country.name}`} breadcrumbs={[{ label: 'Backoffice', href: '/backoffice/dashboard' }, { label: 'Jurisdictions', href: '/backoffice/countries' }, { label: country.name, href: `/backoffice/countries/${country.id}` }, { label: 'New State' }]}>
      <div className="space-y-6">
        <div className="mb-8">
          <h1 className="text-xl font-semibold tracking-tight">New State</h1>
        </div>
        <form onSubmit={e => { e.preventDefault(); post(`/backoffice/countries/${country.id}/states`) }} className="max-w-sm space-y-6">
          <FormSection>
            <div className="space-y-3">
              <div className="space-y-1.5">
                <label className="text-[12px] font-medium text-muted-foreground uppercase tracking-wider">Code</label>
                <Input className="h-8 text-sm" value={data.code} onChange={e => setData('code', e.target.value)} placeholder="CA" />
                {errors.code && <p className="text-[12px] text-destructive">{errors.code}</p>}
              </div>
              <div className="space-y-1.5">
                <label className="text-[12px] font-medium text-muted-foreground uppercase tracking-wider">Name</label>
                <Input className="h-8 text-sm" value={data.name} onChange={e => setData('name', e.target.value)} placeholder="California" />
                {errors.name && <p className="text-[12px] text-destructive">{errors.name}</p>}
              </div>
            </div>
          </FormSection>
          <div className="flex gap-2">
            <Button type="submit" size="sm" disabled={processing} className="h-8 text-[13px]">Create State</Button>
            <Button type="button" size="sm" variant="ghost" onClick={() => window.history.back()} className="h-8 text-[13px]">Cancel</Button>
          </div>
        </form>
      </div>
    </BackofficeLayout>
  )
}
